"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_1 = require("../component/styled");
exports.default = function (_a) {
    var children = _a.children;
    return (/** @class */ (function (_super) {
        __extends(ActionButton, _super);
        function ActionButton() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.preventBubblingUp = function (event) { event.preventDefault(); };
            _this.handleClick = function (e) {
                var onClick = _this.props.onClick;
                onClick && onClick(e);
            };
            return _this;
        }
        ActionButton.prototype.render = function () {
            var _a = this.props, theme = _a.theme, isDisabled = _a.isDisabled;
            return (React.createElement("div", { className: theme.buttonWrapper, onMouseDown: this.preventBubblingUp },
                React.createElement(styled_1.ItemButton, { className: theme.button, onClick: this.handleClick, disabled: !!isDisabled, type: "button", children: children })));
        };
        return ActionButton;
    }(React.Component)));
};
